/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-25 13:45:04
 */

export default {
  path: "publicTask",
  component: () =>
    import(/* webpackChunkName: "position-list" */ "@/pages/publicTask/List"),
  meta: { title: "公域任务发布", cate: "操作中心" },
  children: [
    {
      path: 'personnelList',
      component: () => import( /* webpackChunkName: "company-list" */ '@/pages/publicTask/personnelList/index'),
      meta: {
        title: '报名审核',
        cate: '操作中心'
      }
    },{
      path: 'personnelDetail',
      component: () => import( /* webpackChunkName: "company-list" */ '@/pages/publicTask/personnelList/detail'),
      meta: {
        title: '详情',
        cate: '操作中心'
      }
    }
    // {
    //   path: "signup",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "position-list" */ "@/pages/position/Signup"
    //     ),
    //   meta: { title: "报名列表" },
    //   hidden: true,
    // },
    // {
    //   path: "create",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "position-list" */ "@/pages/position/CreateEdit"
    //     ),
    //   meta: { title: "发布岗位" },
    //   hidden: true,
    // },
  ],
};
